module.exports = __webpack_public_path__ + "img/cat.0c88cdbe.svg";